export default "__VITE_ASSET__Cy7tYyRX__"